import { render } from "./ItemHistoryModal.vue?vue&type=template&id=99164aac&scoped=true"
import script from "./ItemHistoryModal.vue?vue&type=script&lang=js"
export * from "./ItemHistoryModal.vue?vue&type=script&lang=js"

import "./ItemHistoryModal.vue?vue&type=style&index=0&id=99164aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99164aac"]])

export default __exports__